import { getComputedColor } from '@/utils/theme';
import Color from 'color';
import styled from 'styled-components';

export const Button = styled.button`
  all: unset;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -10%;
  z-index: 2;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.vars.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  color: ${({ theme }) => theme.vars.palette.text.primary};
  opacity: 0;

  &:hover {
    opacity: 1;
    background-color: ${({ theme }) =>
      Color(getComputedColor(theme.vars.palette.primary.main))
        .darken(0.2)
        .toString()};
  }

  i {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    opacity: 1;
    right: 0;
  }
`;

export const Container = styled.div`
  .card {
    width: 100%;
    position: absolute;
    z-index: 1;

    &:hover {
      ${Button} {
        opacity: 1;
      }
    }
  }

  .card-next-1 {
    z-index: 0;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(
        to left,
        ${({ theme }) => theme.vars.palette.background.paper},
        transparent 75%
      );
    }
  }

  .card-next-2 {
    z-index: -1;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(
        to left,
        ${({ theme }) => theme.vars.palette.background.paper},
        transparent 80%
      );
    }
  }

  &:hover {
    ${Button} {
      opacity: 1;
    }
  }
`;
